export type AppointmentStatus = 'all' | 'new' | 'dispatched' | 'cancelled' | 'completed'

export interface Appointment {
  uuid: string
  buildingUUID: string
  scheduleStartTime: string | null
  createdAt: string
  updatedAt: string
  customerAccountUUID: string | null
  scoutUUID?: string | null
  scoutName?: string | null
  status: AppointmentStatus
  type: string
  subtypes?: string[] | null
  sc2Url?: string | null
  customerAddress: string
  customerName: string
  customerPhone: string
  customerEmail: string
  dataCollected: boolean
  proposedDate1?: string | null
  proposedTimeRange1?: string | null
  proposedDate2?: string | null
  proposedTimeRange2?: string | null
  proposedDate3?: string | null
  proposedTimeRange3?: string | null
  scoutCount?: number | null
  scoutNotificationSent?: string | null
  confirmationEmailSent?: string | null
  reminderEmailSent?: string | null
  scoutCreated?: boolean
  funnel?: string
  residentialUnits?: number | null
  costPerOSA?: number | null
  bauhowLink?: string | null
  salesComment?: string | null
  lastComment?: {
    uuid: string
    objectUuid: string
    commentText: string
    date: string
  }
}

export const APPOINTMENT_STATUS_LABELS: Record<AppointmentStatus, string> = {
  all: 'All',
  new: 'New',
  dispatched: 'Dispatched',
  cancelled: 'Cancelled',
  completed: 'Completed',
}

export interface ScoutAssignment {
  UUID: string
  OnsiteAppointmentUUID: string
  ScoutUUID: string
  Status: string
  SelectedStartTime: string | null
  Distance: number
  ScoutFirstName: string
  ScoutLastName: string
  EmailStatus?: string | null
}

// One recorded change of an appointment. changedFields holds only the
// columns that changed, keyed by database column name, with their new values.
export interface AppointmentHistoryEntry {
  changedFields: Record<string, unknown>
  changedDate: string
  changedBy: string
}

export interface CreateScoutOsaRatingInput {
  scoutUUID: string
  userEmail: string
  photoSketchRating: number
  roomCaptureRating: number
  overallExpertiseRating: number
  note?: string
}

export interface ScoutOsaRating {
  uuid: string
  onsite_appointment_uuid: string
  scout_uuid: string
  scout_name: string
  user_email: string
  photo_sketch_rating: number
  room_capture_rating: number
  overall_expertise_rating: number
  note?: string | null
  created_at: string
  updated_at: string
}

export const SCOUT_RATING_CATEGORIES = [
  { key: 'photoSketchRating', field: 'photo_sketch_rating', label: 'Fotoqualität & Skizzen' },
  {
    key: 'roomCaptureRating',
    field: 'room_capture_rating',
    label: 'Raumaufnahmen, Heizkörper & Scans',
  },
  {
    key: 'overallExpertiseRating',
    field: 'overall_expertise_rating',
    label: 'Gesamtexpertise Scout',
  },
] as const
